import { useFeatureIsOn } from 'src/common/growthbook';

export function useShowWebPushNotificationStepEnabled(): boolean {
  return useFeatureIsOn('enable-web-push-notifications');
}
